<template>
    <!-- 전체 콘텐츠 영역 -->    
    <div class="main-contents">        
        <div class="mem_container">            
            <div class="mem_info_contents">
                <tecInfo v-model="data" type="clientEval" :tecMberSeq="$route.params.tecMberSeq" :prjtStat="$route.params.prjtStat" :nameViewYn="$route.params.nameViewYn"/>

                <tec-resume-view ref="tecResumeView" v-model="resume"  :tecMberSeq="$route.params.tecMberSeq" :insertViewHistoryFlag="'Y'"/>

                <div class="btn-prj-detail">
                    <span class="btn-list" @click="$router.go(-1)">
                        &lt; 목록보기
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tecInfo from "@/components/highpro/TecInfo.vue";
import tecResumeView from "@/components/highpro/TecResumeView.vue";

export default {
    beforeMount() {
    },
    components: { tecInfo, tecResumeView },

    data() {
        return {
            notiState : '',
            data:{},
            state : {},
            info: { },
            resume: { },
        };
    }, 
        
    };
</script>